export const LC_IMG = "/lockCalculator";
